module.exports = import("https://unpkg.com/webamp@0.0.0-next-bd2022a8/built/webamp.bundle.min.js");;